enum contactConstants {
    SUBMIT_FORM = "contact/SUBMIT_FORM",
    SUBMIT_FORM_SUCCESS = "contact/SUBMIT_FORM_SUCCESS",
    SUBMIT_FORM_FAILED = "contact/SUBMIT_FORM_FAILED",

    CLEAR = "contact/CLEAR"
}

export default contactConstants;
